import React from "react";

import type {
  DescriptionFile,
  DescriptionFileValidation,
} from "../../../../application/domain/proc-management";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { FileInput, FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextInput } from "./simple-text-input";
import type { FileInputProps, InputProps, PathProps } from "./types";

type DescriptionFileInputProps = DescriptionFile &
  InputProps &
  FileInputProps &
  PathProps & { validationErrors?: DescriptionFileValidation };

export const DescriptionFileInput: React.FC<DescriptionFileInputProps> = ({
  name,
  fileName,
  basePath,
  onChange,
  onFileAttached,
  getFileUploading,
  disabled = false,
  shouldDisplayError = false,
  validationErrors,
}) => {
  const loading = getFileUploading(basePath);
  return (
    <div>
      <div className="mb-2">
        <FormFieldLabel label="表示ファイル名" bold={false} required />
        <SimpleTextInput
          onChange={onChange}
          basePath={[...basePath, "name"]}
          value={name}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.name}
          maxLength={getMaxLength("descriptionFileName")}
        />
      </div>

      <div className="mb-2">
        <FormFieldLabel label="ファイル" bold={false} required />
        <InputNoticeList
          notices={[
            "ユーザーがダウンロード可能なファイルをアップロードします。次の拡張子をサポートしています；",
            ".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .rtf",
          ]}
        />
        <FileInput
          label="ファイルをアップロード"
          onFileAttached={(event) => {
            onFileAttached(basePath, event);
          }}
          hasName
          attachedFileName={fileName}
          loading={loading}
          disabled={disabled}
          shouldDisplayError={shouldDisplayError}
          errorMsg={validationErrors?.file}
        />
      </div>
    </div>
  );
};
